import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Drawer,
  IconButton,
  Hidden,
  Container,
  Grid,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import {
  sectionLinks,
  sectionLinks2,
  footerLinks,
  mobfooterLinks,
  mobilesectionLinks2,
} from "./utils";
import { useSelector, useDispatch } from "react-redux";
import { AutoSuggestField } from "../../components";
import Group from "../../assets/images/Group.svg";
import Doctall from "../../assets/images/doctall.svg";
import Logo from "../../assets/images/logo.svg";
import AppStore from "../../assets/images/AppStore.svg";
import GooglePlay from "../../assets/images/GooglePlay.svg";
import Icon from "../../assets/images/Icon.svg";
import Icon2 from "../../assets/images/Icon2.svg";
import Icon4 from "../../assets/images/Icon4.svg";
import Icon5 from "../../assets/images/linkedIN.svg";
import Close from "../../assets/images/close.svg";
import DownArrow from "../../assets/images/sectionarrow.svg";
import MenuIcon from "../../assets/images/MobMenu.png";
import SearchIcon from "../../assets/images/MobSearch.png";
import FooterIcon from "../../assets/images/MobFooterDrop.png";
import SearchBack from "../../assets/images/searchBack.svg";
import SearchClose from "../../assets/images/searchClose.svg";
import DropItem from "../../assets/images/dropSys.svg";
import RadioDrop from "../../assets/images/radiodrop.svg";
import { useHistory } from "react-router-dom";
import useOnClickOutside from "../../hooks/useOutsideClickhandler";
import { logout, SearchVal } from "../../redux/auth/actions";
import useWindowSize from "../../hooks/useWindowSize";
import axios from "axios";

import styles from "./styles";
import "./HeaderFooterStyles.scss";

const useStyles = makeStyles((theme) => styles(theme));

/**
 *
 * @param {object} props
 * @returns
 */
export default function HeaderAndFooter(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [auth, setAuth] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const { children, searching } = props;
  const [drawerOpen, setDrawer] = React.useState(false);
  const [submenu, setMenu] = React.useState("Dianostic");
  const [authMenu, setAuthMenu] = useState(false);
  const classes = useStyles();
  const [width, height] = useWindowSize();
  const [mobileview, setMobileView] = useState(false);
  const [sideoption, setsideoption] = useState("");
  const [searchselection, setSearchselection] = useState(false);
  const [searchtxt, setsearchtxt] = useState("");
  const [fetchData, setFetchData] = useState([]);

  const [footer, setfooterselection] = useState([]);
  const [update, setupdate] = useState(false);
  useEffect(() => {
    if (width && width < 960) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, [width]);
  const handleDrawerToggle = () => {
    setDrawer(!drawerOpen);
  };
  useEffect(() => {
    if (user.isAuthenticated === true && user.verified === true) {
      setAuth(true);
    } else {
      setAuth(false);
    }
  }, [user.isAuthenticated]);
  const setfooter = (type) => {
    let arr = footer;
    if (footer.indexOf(type) > -1) {
      arr = footer.filter((e) => e != type);
    } else {
      arr.push(type);
    }
    setfooterselection(arr);
    setupdate(!update);
  };
  const apiFetch = async (val) => {
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/labtest/diagnostic/searchLists?value=${val}`
      )
      .then((res) => {
        if (res.statusText === "OK" || res.status === 200) {
          let brdata = [];
          res.data.data.map((i) => {
            brdata.push({ name: i.standardisedtestname, uuid: i.uuid });
          });
          setFetchData(brdata);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function getSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === "") {
      return [];
    }

    const regex = new RegExp("^" + escapedValue, "i");

    return fetchData.filter((i) => regex.test(i.name));
  }
  const onChange = (event) => {
    setsearchtxt(event.target.value);
    apiFetch(event.target.value);
    if (event.target.value.length === 0) {
      dispatch(SearchVal(...getSuggestions(event.target.value)));
    }
  };
  const onClear = () => {
    setsearchtxt("");
    setSearchselection(false);
    setFetchData([]);
    dispatch(SearchVal(...getSuggestions("")));
  };
  return (
    <div>
      <Grid container>{children}</Grid>
      <Grid container direction="column" className={classes.footer}>
        <Grid
          container
          xs={12}
          alignItems="center"
          justify="center"
          style={{ padding: "15px 0px" }}
        >
          <Grid
            container
            alignItems="center"
            justify="space-between"
            spacing={3}
          >
            <Grid
              item
              md={6}
              style={{ fontFamily: "visuelt-regular", fontSize: 24 }}
            >
              Get Doctall Diagnostics to your inbox
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={7} xs={12}>
                  <input
                    type="text"
                    style={{ border: 0, outline: "none" }}
                    className={classes.InputMail}
                    placeholder="e.g someone@gmail.com"
                  />
                </Grid>
                <Grid item lg={5} xs={12}>
                  <button className={classes.MailBtn}>Join Mailing List</button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          style={{ paddingBottom: "15px", paddingTop: "10px" }}
        >
          <hr />
        </Grid>
        <Grid item xs={12}>
          <Grid container direction="row" justify="space-between" spacing={3}>
            <Grid item md={4}>
              <Grid container direction="column" spacing={3}>
                <Grid item xs={12}>
                  <img src={Logo} alt="Logo" />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    fontFamily: "visuelt-regular",
                    fontSize: mobileview ? 16 : 14,
                  }}
                >
                  Doctall is a full-circle digital healthcare provider offering
                  comprehensive primary and secondary medical services
                  accessible anywhere, to everyone.
                </Grid>
                <Grid item xs={12}>
                  <a
                    style={{
                      fontFamily: "visuelt-regular",
                      fontSize: mobileview ? 16 : 14,
                    }}
                    href="tel:09010996000"
                  >
                    {/* +234-8301-340-3946 */}
                    09010996000
                  </a>
                  <div>
                    <a
                      style={{
                        fontFamily: "visuelt-regular",
                        fontSize: mobileview ? 16 : 14,
                      }}
                      href="mailto:info@doctall.com"
                    >
                      info@doctall.com
                    </a>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    justify="space-between"
                    style={{ maxWidth: "150px" }}
                  >
                    <Grid item>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/myDoctall/"
                      >
                        <img src={Icon2} alt="Icon2" />
                      </a>
                    </Grid>
                    <Grid item>
                      <a target="_blank" href="https://twitter.com/myDoctall">
                        <img src={Icon} alt="Icon" />
                      </a>
                    </Grid>
                    <Grid item>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/mydoctall/"
                      >
                        <img src={Icon4} alt="Icon4" />
                      </a>
                    </Grid>
                    <Grid item>
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/company/doctall/"
                      >
                        <img src={Icon5} alt="Icon4" />
                      </a>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item container direction="column" md={8}>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
              >
                {(mobileview ? mobfooterLinks || [] : footerLinks || []).map(
                  (f) => (
                    <Grid
                      key={f.id}
                      item
                      xs={6}
                      md={2}
                      style={{ padding: mobileview ? "12px" : "0" }}
                    >
                      {f.subroute && (
                        <Grid
                          container
                          style={{
                            marginBottom: 20,
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            className={classes.title}
                            onClick={() => {
                              setfooter(f.subroute.title);
                            }}
                          >
                            {f.subroute.title}{" "}
                            <img className="mob-footer-drop" src={FooterIcon} />
                          </Grid>
                          {f.subroute.routes && f.subroute.routes.length > 0
                            ? (((mobileview &&
                                footer.indexOf(f.subroute.title) > -1) ||
                                !mobileview) && (
                                <Grid container spacing={2}>
                                  {(f.subroute.routes || []).map((r) => (
                                    <Grid key={r.id} item xs={12}>
                                      <a
                                        target="_blank"
                                        style={{
                                          fontFamily: "visuelt-regular",
                                          fontSize: 16,
                                        }}
                                        href={r.path}
                                      >
                                        {r.label}
                                      </a>
                                    </Grid>
                                  ))}
                                </Grid>
                              )) ||
                              ""
                            : null}
                        </Grid>
                      )}
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          className={classes.title}
                          onClick={() => {
                            setfooter(f?.title);
                          }}
                        >
                          {f.title}{" "}
                          <img className="mob-footer-drop" src={FooterIcon} />
                        </Grid>
                        {f.routes && f.routes.length > 0
                          ? (((mobileview && footer.indexOf(f.title) > -1) ||
                              !mobileview) && (
                              <Grid container spacing={2}>
                                {(f.routes || []).map((r) => (
                                  <Grid key={r.id} item xs={12}>
                                    <a
                                      target="_blank"
                                      style={{
                                        fontFamily: "visuelt-regular",
                                        fontSize: 16,
                                      }}
                                      href={r.path}
                                    >
                                      {r.label}
                                    </a>
                                  </Grid>
                                ))}
                              </Grid>
                            )) ||
                            ""
                          : null}
                      </Grid>
                    </Grid>
                  )
                )}
              </Grid>
              <Grid item>
                <Grid item xs={12} style={{ paddingTop: "125px" }}>
                  <Grid container alignItems="center">
                    <Grid
                      item
                      style={{ marginRight: "50px", marginBottom: "5px" }}
                    >
                      <a
                        target="_blank"
                        href="https://apps.apple.com/ng/app/doctall/id1544455716"
                      >
                        <img src={AppStore} alt="AppStore" />
                      </a>
                    </Grid>
                    <Grid
                      item
                      style={{ marginRight: "50px", marginBottom: "5px" }}
                    >
                      <a
                        target="_blank"
                        href="https://play.google.com/store/apps/details?id=com.doctall"
                      >
                        <img src={GooglePlay} alt="GooglePlay" />{" "}
                      </a>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ paddingTop: "15px", paddingBottom: "15px" }}
        >
          <hr />
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          {`© Doctall ${new Date().getFullYear()},  All Rights Reserved`}
        </Grid>
      </Grid>
    </div>
  );
}
const DropClick = (props) => {
  const ref = React.useRef();
  const [drop, setDrop] = React.useState(false);
  const [selection, setSelection] = React.useState("Pathology");
  useOnClickOutside(ref, () => {
    setDrop(false);
  });
  return (
    <div
      style={{ position: "relative", paddingLeft: 10 }}
      ref={ref}
      onClick={() => {
        setDrop(!drop);
      }}
    >
      <img style={{ cursor: "pointer" }} src={DownArrow} />
      {drop && (
        <div
          style={{
            position: "absolute",
            top: 37,
            right: -35,
            backgroundColor: "#ffffff",
            maxWidth: 235,
            minWidth: 200,
            boxShadow: "0px 4px 6px 2px #F5F9FF",
            border: "1px solid #E3EAF6",
            zIndex: 99,
          }}
        >
          <div
            onClick={() => {
              setSelection("Pathology");
            }}
            style={
              selection == "Pathology"
                ? {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F2F5FE",
                    borderRightColor: "#FFAD05",
                    borderRightWidth: 2,
                    borderRightStyle: "solid",
                  }
                : {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                  }
            }
          >
            <img style={{ paddingRight: 8, width: 18 }} src={DropItem} />
            Pathology
          </div>
          <div
            onClick={() => {
              setSelection("Radiology");
            }}
            style={
              selection == "Radiology"
                ? {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F2F5FE",
                    borderRightColor: "#FFAD05",
                    borderRightWidth: 2,
                    borderRightStyle: "solid",
                  }
                : {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                  }
            }
          >
            <img style={{ paddingRight: 8, width: 18 }} src={RadioDrop} />
            Radiology
          </div>
        </div>
      )}
    </div>
  );
};
